import { Ng2StateDeclaration } from '@uirouter/angular';
import { FiBusinessUnitStateResolveBusinessUnit } from './resolve/business-unit';
import { FiBusinessUnitStateResolveBusinessUnitDataFields } from './resolve/business-unit-data-fields';
import { FiBusinessUnitStateResolvePageTitle } from './resolve/page-title';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiBusinessUnitEditNewLayoutComponent } from '@fi-app/business-unit/business-unit-edit/fi-business-unit-edit-new-layout/fi-business-unit-edit-new-layout.component';
import {
    FiCoreUnitResolve_lightWeightAreas,
    FiCoreUnitResolve_lightWeightBusinessAreas,
    FiCoreUnitResolve_lightWeightClusters,
    FiCoreUserUnitResolve_accessRightFilterCollection,
} from '@fi-app/business-unit/states/resolve/access-right';

export const FiBusinessUnitEditV2State: Ng2StateDeclaration = {
    name: FiStateNames.BusinessUnit.EditV2,
    url: '/:Id/EditV2',
    views: {
        '@': {
            component: FiBusinessUnitEditNewLayoutComponent,
        },
    },
    resolve: {
        businessUnit: FiBusinessUnitStateResolveBusinessUnit,
        lightWeightClusters: FiCoreUnitResolve_lightWeightClusters,
        lightWeightBusinessAreas: FiCoreUnitResolve_lightWeightBusinessAreas,
        areasAvailableForBusinessUnit: FiCoreUnitResolve_lightWeightAreas,
        accessRightFilterCollection: FiCoreUserUnitResolve_accessRightFilterCollection,
        businessUnitDataFields: FiBusinessUnitStateResolveBusinessUnitDataFields,
        pageTitle: FiBusinessUnitStateResolvePageTitle,
    },
};
